import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import { AuthProvider } from './common/contexts/authContext';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { RequestsProvider } from './common/contexts/requestsContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { NewMessageQueueProvider } from './common/contexts/messageQueueContext/messageQueueContext';
import { TranslationProvider } from './common/contexts/translationContext';
import {
	clearLegacyClientStorage,
	queryClient,
} from './common/functions/clearLegacyClientStorage';

clearLegacyClientStorage();

// styled-components v6 forwards every prop to the DOM; keep the v5 behaviour of
// passing only valid HTML attributes to DOM elements (custom components still
// receive all props).
const shouldForwardProp = (propName, target) =>
	typeof target === 'string' ? isPropValid(propName) : true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<StyleSheetManager shouldForwardProp={shouldForwardProp} enableVendorPrefixes>
		<BrowserRouter>
			<QueryClientProvider client={queryClient}>
				<RequestsProvider>
					<AuthProvider>
						<NewMessageQueueProvider>
							<TranslationProvider>
								<App />
							</TranslationProvider>
						</NewMessageQueueProvider>
					</AuthProvider>
				</RequestsProvider>
			</QueryClientProvider>
		</BrowserRouter>
	</StyleSheetManager>,
);
